import React from 'react';
import { Navigate, Route } from 'react-router-dom';


const Factory = ( modules, metadata ) => {

  const Pages = require( '../../../pages/modules' ).default;

  const Page = Pages.Meta[ modules.handle.Page ];

  return (
    <>

      <Route index element={<Navigate to={`/${modules.handle.section}`} replace />} />
      <Route path={modules.handle.section} element={<Page />} />

      {modules.identity.map( ( item ) => {

        const Page = Pages.Meta[ item.Page ];

        return <Route path={item.section} element={<Page />} />;
      } )}

    </>
  );
};

export default Factory;